/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _style3 = require('antd/lib/icon/style');

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style4 = require('antd/lib/tabs/style');

var _tabs = require('antd/lib/tabs');

var _tabs2 = _interopRequireDefault(_tabs);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('./index.less');

var _index = require('./charge/index');

var _index2 = _interopRequireDefault(_index);

var _index3 = require('./bat/index');

var _index4 = _interopRequireDefault(_index3);

var _index5 = require('./sourceEdge/index');

var _index6 = _interopRequireDefault(_index5);

var _index7 = require('./secondarySide/index');

var _index8 = _interopRequireDefault(_index7);

var _tool = require('../../../utils/tool');

var _config = require('../../../utils/config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TabPane = _tabs2.default.TabPane;

var Battery = function (_Component) {
    (0, _inherits3.default)(Battery, _Component);

    function Battery(props) {
        (0, _classCallCheck3.default)(this, Battery);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Battery.__proto__ || (0, _getPrototypeOf2.default)(Battery)).call(this, props));

        _this.state = {
            detail: {},
            refresh: false
        };
        return _this;
    }

    (0, _createClass3.default)(Battery, [{
        key: 'refresh',
        value: function refresh() {
            // location.reload()
            this.setState({
                refresh: true
            });
            this.getDetailIndex();
        }
    }, {
        key: 'callback',
        value: function callback(key) {
            console.log(key);
        }
    }, {
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.getDetailIndex();
        }
    }, {
        key: 'getDetailIndex',
        value: function getDetailIndex() {
            var _this2 = this;

            (0, _tool.http)(_config.apiJson.getCabinetInfo, {
                deviceId: this.props.params.did,
                batteryCabinetNum: this.props.params.batteryCabinetNum
            }).then(function (res) {
                _this2.setState({
                    detail: res,
                    refresh: false
                });
            });
        }
    }, {
        key: 'HocTap',
        value: function HocTap(WrappedComponent, deviceId, batteryCabinetNum, deviceType) {
            var _ref = (0, _jsx3.default)(WrappedComponent, {
                deviceId: deviceId,
                batteryCabinetNum: batteryCabinetNum,
                deviceType: deviceType
            });

            return function () {
                function WrappingComPonent(props) {
                    return _ref;
                }

                return WrappingComPonent;
            }();
        }
    }, {
        key: 'render',
        value: function render() {
            var detail = this.state.detail;
            var type = this.props.params.type;

            var HocCharge = this.HocTap(_index2.default, this.props.params.did, this.props.params.batteryCabinetNum, this.props.params.type);
            var HocBats = this.HocTap(_index4.default, this.props.params.did, this.props.params.batteryCabinetNum, type);
            return (0, _jsx3.default)('div', {
                className: 'battery'
            }, void 0, (0, _jsx3.default)('div', {
                className: 'battery-tit'
            }, void 0, (0, _jsx3.default)('h3', {}, void 0, '\u8BBE\u5907\u7F16\u53F7\uFF1A', (0, _jsx3.default)('span', {}, void 0, this.props.params.bid)), (0, _jsx3.default)('p', {}, void 0, '\u7535\u6C60\u4ED3\u7F16\u53F7\uFF1A', (0, _jsx3.default)('span', {}, void 0, this.props.params.batteryCabinetNum)), (0, _jsx3.default)('div', {
                className: 'battery-refresh',
                onClick: this.refresh.bind(this)
            }, void 0, (0, _jsx3.default)(_icon2.default, {
                type: 'sync',
                spin: this.state.refresh,
                onClick: this.refresh.bind(this)
            }))), (0, _jsx3.default)('div', {
                className: 'battery-status'
            }, void 0, (0, _jsx3.default)('div', {}, void 0, '\u9501\u72B6\u6001\uFF1A', (0, _jsx3.default)('span', {}, void 0, _tool.filter.lockStatus(detail.lockStatus))), (0, _jsx3.default)('div', {}, void 0, '\u7535\u6C60\u72B6\u6001\uFF1A', (0, _jsx3.default)('span', {}, void 0, _tool.filter.batteryStatus(detail.batteryStatus))), (0, _jsx3.default)('div', {}, void 0, '\u9884\u7EA6\u72B6\u6001\uFF1A', (0, _jsx3.default)('span', {}, void 0, _tool.filter.bookingStatus(detail.bookingStatus))), (0, _jsx3.default)('div', {}, void 0, '\u5145\u7535\u63A5\u53E3\u72B6\u6001\uFF1A', (0, _jsx3.default)('span', {}, void 0, _tool.filter.chargerStatus(detail.chargerStatus)))), (0, _jsx3.default)('div', {
                className: 'battery-xxk'
            }, void 0, (0, _jsx3.default)(_tabs2.default, {
                defaultActiveKey: '1',
                onChange: this.callback.bind(this)
            }, void 0, (0, _jsx3.default)(TabPane, {
                tab: '\u5145\u7535\u673A'
            }, '1', (0, _jsx3.default)(HocCharge, {})), (0, _jsx3.default)(TabPane, {
                tab: '\u7535\u6C60'
            }, '2', (0, _jsx3.default)(HocBats, {})), type !== '331' && type !== '332' && type !== '335' ? (0, _jsx3.default)(TabPane, {
                tab: '\u65E0\u7EBF\u6E90\u8FB9'
            }, '3', (0, _jsx3.default)(_index6.default, {
                deviceId: this.props.params.did,
                batteryCabinetNum: this.props.params.batteryCabinetNum
            })) : '', type !== '331' && type !== '332' && type !== '335' ? (0, _jsx3.default)(TabPane, {
                tab: '\u65E0\u7EBF\u526F\u8FB9'
            }, '4', (0, _jsx3.default)(_index8.default, {
                deviceId: this.props.params.did,
                batteryCabinetNum: this.props.params.batteryCabinetNum
            })) : '')));
        }
    }]);
    return Battery;
}(_react.Component);

exports.default = Battery;

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/sbDevice/batteryInfo/index.jsx
// module id = 1550
// module chunks = 0